import _styled from "@emotion/styled-base";
import { css } from "@emotion/core";
import { remRhythm } from "../css";

var ComboboxSectionTitle = /*#__PURE__*/_styled("div", {
  target: "e1q4uwee0"
})(function (_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/css("label:base;font-size:", theme.fontSizes.xs, ";margin:0;padding:", remRhythm(1 / 8), " ", remRhythm(3 / 8), ";color:", theme.colors.muted, ";&:not(:first-of-type){margin-top:", remRhythm(5 / 16), ";}");
});

ComboboxSectionTitle.displayName = "ComboboxSectionTitle";
export default ComboboxSectionTitle;